import api from '@/services/api';
import store from '@/store';

export default {
  async getLimiteJeux(category) {
    return new Promise((resolve, reject) => {
      const withCredentials = {
        withCredentials: true,
      };
      api
        .call(`account-api/v2/players/limits/${category}`, 'getLimiteJeux', 'GET', {
          withCredentials,
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          // eslint-disable-next-line no-undef
          // store.commit('encadrerJeux/RESET_CATEGORY', category);
          store.commit('encadrerJeux/SET_LIMITS', response.data);
          resolve(response.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },

  async setLimiteJeux({ category, period, value }) {
    return new Promise((resolve, reject) => {
      const laLimite = store.getters['encadrerJeux/getLimits'];
      const { actuelValue } = laLimite[category][period];
      const withCredentials = {
        withCredentials: true,
      };
      const data = {
        value,
        actuelValue,
      };

      api
        .call(`account-api/v2/players/limits/${category}/${period}`, 'setLimiteJeux', 'POST', {
          withCredentials,
          data,
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          store.commit('encadrerJeux/SET_CATEGORY_LIMIT', response.data);
          resolve(response.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },

  async deleteLimiteJeux({ category, period }) {
    return new Promise((resolve, reject) => {
      const withCredentials = {
        withCredentials: true,
      };
      api
        .call(`account-api/v2/players/limits/${category}/${period}`, 'deleteLimiteJeux', 'DELETE', {
          withCredentials,
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          store.commit('encadrerJeux/SET_CATEGORY_LIMIT', response.data);
          resolve(response.data);
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        });
    });
  },
};
